import React, { ReactNode } from 'react';

interface UserErrorBoundaryProps {
  children: ReactNode;
}

interface UserErrorBoundaryState {
  hasError: boolean;
}

/**
 * Error boundary component for handling errors in the user context
 */
class UserErrorBoundary extends React.Component<UserErrorBoundaryProps, UserErrorBoundaryState> {
  constructor(props: UserErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): UserErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('UserContext Error:', error, errorInfo);
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <div className="text-center p-4">
          <h2>Something went wrong loading user data.</h2>
          <button 
            onClick={() => window.location.reload()} 
            className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Retry
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default UserErrorBoundary; 